import React from 'react';
import './MenuItem.css';
import { Link } from 'react-router-dom';



const MenuItem = ({ item }) => {

  return (
    <div className="menu-item">

      <div className='image'>
        <img src={item.image} alt={item.title} /> {/* Menu Item Image */}
      </div>

      <div className="content">

        <div className="intro">
          {/* Link to the individual Menu Dish page */}
          <Link
            to={{ 
              pathname: '/Menu/' + item.title + '/Menu-Single',  // Navigate to the specific menu dish page
            }}
            location = {{item}}  // Passing menu dish details to the linked page
            state= {item}> 
            <h4>{item.title}</h4> {/* Menu Dish Title */}
          </Link>
          <span className="line"></span> {/* Decorative Line */}
          <h5 className="price"><span>$</span>{item.details.price}</h5> {/* Menu Dish Price */}
        </div>

        <p>{item.content}</p> {/* Menu Dish Description */}

      </div>

    </div>
  );
};

export default MenuItem;